import { createSlice } from '@reduxjs/toolkit';
import { regenerateReport } from '../../../rtk-apis/reports/regenerateReport';

const initialState = {
  status: '',
  msg: '',
  loading: false,
};

const regenerateReportSlice = createSlice({
  name: 'regenerateReportSlice',
  initialState,
  reducers: {
    clearRegenerateReport: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(regenerateReport.pending, state => {
        state.loading = true;
        state.status = '';
        state.msg = '';
      })
      .addCase(regenerateReport.fulfilled, state => {
        state.loading = false;
        state.status = 'SUCCESS';
      })
      .addCase(regenerateReport.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action.payload || 'Could not regenerate the report.';
      });
  },
});

export const { clearRegenerateReport } = regenerateReportSlice.actions;
export default regenerateReportSlice.reducer;
